var productCardMarkup = `
 <div class="swym-wishlist-detail-content empty-container" style="display:none"><div class="swym-empty-wishlist-container"><h3 class="swym-empty-wishlist-title swym-heading swym-heading-1"> Tu wishlist está vacía </h3><p class="swym-empty-wishlist-text swym-text swym-text-1" style="text-align:center">Guardá tus items favoritos para no perderlos de vista.</p><a class="swym-empty-wishlist-continue-btn swym-button swym-button-1 swym-is-button swym-bg-2 swym-color-4" href="/">Seguir comprando</a></div></div>
 <ul style="display:none" class="wishlist-products-ul">
  


 {{#products}}
	<li class="grid__item grid__item--collection-template small--one-half medium-up--one-third wishlist_product">
	<span class="product_url" url="{{du}}" style="display:none !important"></span>
      <div class="grid-view-item product-card">
		<a class="remove-product" href="javascript:;" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}"> X </a>
        <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{du}}">
        </a>
 
        <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
          <div style="padding-top: 66.66666666666666%;">
			<a href="{{du}}"><img  class="grid-view-item__image lazyautosizes" src="{{iu}}" /></a>
          </div>
        </div>

		<div class="h4 grid-view-item__title product-card__title product-title-wishlist-{{epi}}" aria-hidden="true">{{dt}} </div>
		<!--<div class="variant-info-{{epi}}">{{variantinfo}}</div>-->
        <dl class="price" data-price="">
		  <span class="price-item price-item--sale product__price product-price-{{epi}}" data-sale-price="">
          </span>
			
        </dl>
        <a href="" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="add-to-cart check-availibility-{{epi}}" style="display: none;">
			{{#isInCart}}Agregado al carrito{{/isInCart}}
			{{^isInCart}}Agregar al carrito{{/isInCart}}
		</a>
        <a href="javascript:;" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="not-in-stock check-sold-out-{{epi}}" style="display: none;">
        	agotado
        </a>
      </div>
    </li>
  {{/products}}
 

 </ul>
`;

function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = " ";
      }
    } else { 
      variantinfo = " ";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      var formattedWishlistedProducts = products.map(function(p){
        var url = p.du;
        var masterUrl = url.concat("?variant=",p.epi);

        jQuery.ajax({
          url: masterUrl,
          dataType: 'json'
        })
        .done(function(data){
          data.product.variants.map(element => {
            if(element.id == p.epi) {
              $(".variant-info-"+p.epi).html(element.title);
            }
          });
          var cpr = data.product.variants[0].compare_at_price;
          $("span.compare_price-"+p.epi).html(p.cu+""+cpr);
          $(".product-title-wishlist-"+p.epi).html(data.product.title);
//           Sold out button          
          data.product.variants.forEach(function(item,index){
            if(item.id == p.epi){
          		if(item.inventory_quantity > 0) {
                  $(".check-availibility-"+p.epi).show();
                  $(".check-sold-out-"+p.epi).hide();
                } else {
                  $(".check-sold-out-"+p.epi).show();
                  $(".check-availibility-"+p.epi).hide();
                }  	
            }
          })
          
          
        });
        
        var promise = $.getJSON(masterUrl);
        promise.done(function(data){
//           var productPrice = data.product.variants[0].price;
//           var objMoney = new theme.Currency;
//           var daPrice = objMoney.formatMoney('' , productPrice);
 		  var productPrice = theme.Currency.formatMoney(data.product.variants[0].price, theme.settings.moneyFormat);
          $(".product-price-"+p.epi).html(productPrice);

       
          
         
        });
        

        p = SwymUtils.formatProductPrice(p);   // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
        return p;
      });
      
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      
      attachClickListeners();
      
    },
    window._swat.EventTypes.addToWishList
  );
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
//   var productId = e.target.getAttribute("data-product-id");
//   var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Agregando...";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "agregado al carrito";
     //window.location.reload();
     console.log("Successfully added product to cart.");     
     var promise = $.getJSON('/cart.js');

promise.done(function(data) {
  var objcart = new theme.CartDrawer();
   objcart.buildCart(data, true, '');
});
     
   },
   function(e) {
     console.log(e);
   }
  );
}


function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
}

// Remove From wishlist
function remove_product_from_wishlist(){
	$(document).on('click','.remove-product',function(){
      let empi = parseInt($(this).attr('data-product-id'));
      let epi = parseInt($(this).attr('data-variant-id'));
      let du = $(this).attr('data-url');
      let me = this;
      
       window._swat.removeFromWishList(
         {
           "epi": epi,
           "empi": empi,
           "du" : du,
         },
         function(r) {
           console.log('Removed From wishlist');
           $(me).parents('li').remove();
         }
         
       );
      window._swat.fetch(function (r) {
           if(r.length == 0){
             $('.icon-wishlist-filled').hide();
             $('.icon-wishlist-empty').show();
             $('.empty-container').show();
             $('.wishlist-products-ul').hide();
           }else{
             $('.empty-container').hide();
             $('.wishlist-products-ul').show();
           }
       });
  });
}
if (!window._swat) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(remove_product_from_wishlist);
}
else {
  remove_product_from_wishlist();
}

let  style = {
            style: 'currency',
            currency: "EUR",
            minimumFractionDigits: 2,
            useGrouping: true
        };
var formatter = new Intl.NumberFormat("es", style);


  

